"use strict";

require("./styles/styles.less");